import { FC, useMemo } from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";
import { kStyleConst } from "../kStyle";
import { kColors } from "../kColors";
import { useDisplayErrorRibbon } from "../redux/errorHandler/actions";
import { TmtTitleHeader } from "./impComponents";

const HeaderNotLoggedIn: FC = () => {
  useDisplayErrorRibbon();

  const _handleNavToHome = () => {
    location.href = "";
  };

  const LogoButton = useMemo(
    () => <TmtTitleHeader style={styles.mHeaderLogoContainer} svgStyle={styles.mHeaderLogo} />,
    [],
  );

  return (
    <>
      <View style={styles.mHeaderContainer}>
        <View style={styles.mHeaderLeft} />
        <TouchableOpacity onPress={_handleNavToHome} style={styles.mHeaderCenter}>
          {LogoButton}
        </TouchableOpacity>
        <View style={styles.mHeaderRight} />
      </View>
    </>
  );
};

export default HeaderNotLoggedIn;

const styles = StyleSheet.create({
  mHeaderCenter: {
    alignContent: "center",
    alignItems: "center",
    flex: 1,
    justifyContent: "center",
    justifyItems: "center",
  },
  mHeaderContainer: {
    alignItems: "center",
    backgroundColor: kColors.white,
    borderBottomColor: kColors.brandGreen,
    borderBottomWidth: 1,
    flexDirection: "row",
    height: kStyleConst.kHeaderHeight,
    justifyContent: "space-between",
    paddingHorizontal: 3 * kStyleConst.kSpacing,
  },
  mHeaderLeft: {
    flex: 1,
    alignItems: "center",
    flexDirection: "row",
  },
  mHeaderLogo: {
    maxWidth: 220,
    width: "100%",
  },
  mHeaderLogoContainer: {
    flex: 1,
    justifyContent: "center",
    minHeight: 25,
    paddingHorizontal: kStyleConst.kSpacing,
  },
  mHeaderMenuIcon: {
    height: 25,
    width: 25,
  },
  mHeaderRight: {
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-end",
    flexDirection: "row",
  },
} as const);
